import { useSelector } from 'react-redux'
import { CustomLink } from '../../../common/CustomLink'
import { TextEllipsisStaticLine } from '../../../common/textEllipsis/TextEllipsisStaticLine'
import { COMPONENTS } from '../../../routers/constants'
import { selectBranchData } from '../store/slice'

export const NameCell = ({ item, val, rowId, isDynamicReport }) => {
  const organizationId = useSelector(selectBranchData(rowId, 'organizationId'))
  const allowRedirectLink = useSelector(
    selectBranchData(rowId, 'allowRedirectLink'),
  )

  return (
    <div style={isDynamicReport ? {} : item.childTdStyle}>
      <CustomLink
        target="_blank"
        to={
          COMPONENTS.companyAnalysis.components.summary.route +
          '?organizationId=' +
          organizationId
        }
        inActive={!allowRedirectLink}
      >
        {isDynamicReport ? (
          item.format(val)
        ) : (
          <TextEllipsisStaticLine
            lineClamp={2}
            text={item.format(val)}
            isI18n={false}
            appendStyle={{
              color: allowRedirectLink && '#2C73E8',
            }}
          />
        )}
      </CustomLink>
    </div>
  )
}
